import { type Database } from "@fitness-app/supabase";

export type ChatResponseMetricEntity = Database["public"]["Tables"]["chat_response_metric"]["Row"];

export enum ChatResponseMetricStatus {
  Pending = "pending",
  Responded = "responded",
  Breached = "breached",
}

export interface ChatResponseMetric extends ChatResponseMetricEntity {
  metadata: Record<string, any>;
  status: ChatResponseMetricStatus;
}
